export const WatchlistAdd = 'WatchlistAdd'
export const WatchlistOpen = 'WatchlistOpen'
export const WatchlistRemove = 'WatchlistRemove'
